import script from "./ProductRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductRow.vue?vue&type=script&setup=true&lang=js"

import "./ProductRow.vue?vue&type=style&index=0&id=7fd7a87c&lang=scss"

const __exports__ = script;

export default __exports__